/**
 * Shared helpers for the sequential submission/invoice numbering scheme.
 * A falsy number means the record was created offline and hasn't synced
 * yet — the real number is assigned atomically by the server the first
 * time it syncs (see lib/sync.js), never guessed on the device.
 */

export function isNumberPending(number) {
  return !number;
}

export function displayNumber(number, t, { short = false } = {}) {
  if (number) return number;
  return t(short ? 'common.number_pending_short' : 'common.number_pending');
}
